import swal from 'sweetalert2';

class UtilizationCodeChecker {

    check(code, area) {


        const PIH01 = '5-185';

        const alertCodes = ['1-214', '5-46', '2-47'];

        var notificatiosQueue = [];

        if(code == "" || code == null ){
            return;
        }

        // var array = code.split("-").map(Number);
        // if (array[0] !== 'undefined' && array[0] == 1) {
        //     if (window.configNotifications.greenPlantNotify) {
        //         notificatiosQueue.push(
        //             {
        //                 msg: '2017.nov.28-tól minimum 60 napos fenntartási kötelezettséggel kell rendelkeznie a területen a zöldugart illetően. (ez visszamenőleg nem érvényesíthető)',
        //                 type: "greenPlantNotify",
        //             }
        //         );
        //     }
        // }

        if (code === PIH01) {
            window.configNotifications.pihCounter = window.configNotifications.pihCounter + 1;
            if (window.configNotifications.pihCounter > 1) {

                if (window.configNotifications.notiflyPIH01) {

                    notificatiosQueue.push(
                        {
                            msg: 'Ha egymást követő három évben PIH01 kódú kultúrát vesz fel, akkor a terület kizárásra kerül a támogatásból!',
                            type: "notiflyPIH01",
                        }
                    );
                }
            }
        }


        if (window.configNotifications.notiflyCodes) {

            var exist = alertCodes.indexOf(code) > -1 ? true : false;


            if (exist) {

                if (area < 0.05) {
                    notificatiosQueue.push(
                        {
                            msg: 'A választott hasznosítás esetében 0.05 Ha a minimum hasznosítható terület!',
                            type: "notiflyCodes",
                        }
                    );
                }

            } else {
                if (area < 0.25) {
                    notificatiosQueue.push(
                        {
                            msg: 'A választott hasznosítás esetében 0.25 Ha a minimum hasznosítható terület!',
                            type: "notiflyCodes",
                        }
                    );
                }
            }

        }

        if (notificatiosQueue.length) {
            this.alert(notificatiosQueue);

        }

    }

    async alert(notificatiosQueue) {

        if (typeof notificatiosQueue[0] == 'undefined') {
            return;
        }

        var notification = notificatiosQueue[0];

        const { value: accept } = await swal({
            type: "warning",
            title: 'Figyelem!',
            input: 'checkbox',
            confirmButtonColor: "#3fa535",
            html: notification.msg,
            inputValue: 0,
            inputPlaceholder:
                'Ne jelenjen meg többet ez az üzenet.',
            confirmButtonText:
                'Rendben',
        })

        if (accept) {
            switch (notification.type) {
                case 'notiflyPIH01':
                    window.configNotifications.notiflyPIH01 = false;
                    break;
                case 'notiflyCodes':
                    window.configNotifications.notiflyCodes = false;
                    break;
                case 'greenPlantNotify':
                    window.configNotifications.greenPlantNotify = false;
                    break;

            }
        }


        var index = notificatiosQueue.indexOf(notification);
        if (index > -1) {
            notificatiosQueue.splice(notification, 1);
        }

        this.alert(notificatiosQueue);

    }


}

export default UtilizationCodeChecker;



// WEBPACK FOOTER //
// ./resources/assets/js/utilities/UtilizationCodeChecker.js